import "@arco-design/web-react/es/Breadcrumb/style";
import _Breadcrumb from "@arco-design/web-react/es/Breadcrumb";
import _IconHome from "@arco-design/web-react/icon/react-icon/IconHome";
import _IconMenuFold from "@arco-design/web-react/icon/react-icon/IconMenuFold";
import _IconMenuUnfold from "@arco-design/web-react/icon/react-icon/IconMenuUnfold";
import _IconTag from "@arco-design/web-react/icon/react-icon/IconTag";
import _IconDashboard from "@arco-design/web-react/icon/react-icon/IconDashboard";
import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import React, { useState, useRef, useMemo, useEffect } from 'react';
import { Switch, Route, Link, Redirect, useHistory } from 'react-router-dom';
import cs from 'classnames';
import { useSelector } from 'react-redux';
import qs from 'query-string';
import NProgress from 'nprogress';
import Navbar from './components/NavBar';
import Footer from './components/Footer';
import useRoute from '@/routes';
import { isArray } from './utils/is';
import useLocale from './utils/useLocale';
import getUrlParams from './utils/getUrlParams';
import lazyload from './utils/lazyload';
import styles from './style/layout.module.less';
const MenuItem = _Menu.Item;
const SubMenu = _Menu.SubMenu;
const Sider = _Layout.Sider;
const Content = _Layout.Content;

function getIconFromKey(key) {
  switch (key) {
    case 'dashboard':
      return /*#__PURE__*/React.createElement(_IconDashboard, {
        className: styles.icon
      });

    case 'example':
      return /*#__PURE__*/React.createElement(_IconTag, {
        className: styles.icon
      });

    default:
      return /*#__PURE__*/React.createElement("div", {
        className: styles['icon-empty']
      });
  }
}

function getFlattenRoutes(routes) {
  const res = [];

  function travel(_routes) {
    _routes.forEach(route => {
      if (route.key && !route.children) {
        route.component = lazyload(() => import(`./pages/${route.key}`));
        res.push(route);
      } else if (isArray(route.children) && route.children.length) {
        travel(route.children);
      }
    });
  }

  travel(routes);
  return res;
}

function PageLayout() {
  const urlParams = getUrlParams();
  const history = useHistory();
  const pathname = history.location.pathname;
  const currentComponent = qs.parseUrl(pathname).url.slice(1);
  const locale = useLocale();
  const settings = useSelector(state => state.settings);
  const userInfo = useSelector(state => state.userInfo);
  const [routes, defaultRoute] = useRoute(userInfo?.permissions);
  const defaultSelectedKeys = [currentComponent || defaultRoute];
  const paths = (currentComponent || defaultRoute).split('/');
  const defaultOpenKeys = paths.slice(0, paths.length - 1);
  const [breadcrumb, setBreadCrumb] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState(defaultSelectedKeys);
  const [openKeys, setOpenKeys] = useState(defaultOpenKeys);
  const routeMap = useRef(new Map());
  const navbarHeight = 60;
  const menuWidth = collapsed ? 48 : settings.menuWidth;
  const showNavbar = settings.navbar && urlParams.navbar !== false;
  const showMenu = settings.menu && urlParams.menu !== false;
  const showFooter = settings.footer && urlParams.footer !== false;
  const flattenRoutes = useMemo(() => getFlattenRoutes(routes) || [], [routes]);
  const [navigationHidden, setNavigationHidden] = useState(false);

  function renderRoutes(locale) {
    const nodes = [];
    routeMap.current.clear();

    function travel(_routes, level, parentNode = []) {
      return _routes.map(route => {
        const {
          breadcrumb = true
        } = route;
        const iconDom = getIconFromKey(route.key);
        const titleDom = /*#__PURE__*/React.createElement(React.Fragment, null, iconDom, " ", locale[route.name] || route.name);

        if (route.component && (!isArray(route.children) || isArray(route.children) && !route.children.length)) {
          routeMap.current.set(`/${route.key}`, breadcrumb ? [...parentNode, route.name] : []);

          if (level > 1) {
            return /*#__PURE__*/React.createElement(MenuItem, {
              key: route.key
            }, titleDom);
          }

          nodes.push( /*#__PURE__*/React.createElement(MenuItem, {
            key: route.key
          }, /*#__PURE__*/React.createElement(Link, {
            to: `/${route.key}`
          }, titleDom)));
        }

        if (isArray(route.children) && route.children.length) {
          const parentNode = [];

          if (iconDom.props.isIcon) {
            parentNode.push(iconDom);
          }

          if (level > 1) {
            return /*#__PURE__*/React.createElement(SubMenu, {
              key: route.key,
              title: titleDom
            }, travel(route.children, level + 1, [...parentNode, route.name]));
          }

          nodes.push( /*#__PURE__*/React.createElement(SubMenu, {
            key: route.key,
            title: titleDom
          }, travel(route.children, level + 1, [...parentNode, route.name])));
        }
      });
    }

    travel(routes, 1); // const list = history.location.pathname.split('/')
    // console.log(history)
    // console.log(list)
    // setBreadCrumb(list)
    // console.log(breadcrumb)

    return nodes;
  }

  function onClickMenuItem(key) {
    const currentRoute = flattenRoutes.find(r => r.key === key);
    const component = currentRoute.component;
    const preload = component.preload();
    NProgress.start();
    preload.then(() => {
      setSelectedKeys([key]);
      history.push(currentRoute.path ? currentRoute.path : `/${key}`);
      NProgress.done();
    });
  }

  function toggleCollapse() {
    setCollapsed(collapsed => !collapsed);
  }

  const paddingLeft = showMenu ? {
    paddingLeft: menuWidth
  } : {};
  const paddingTop = showNavbar ? {
    paddingTop: navbarHeight
  } : {};
  const paddingStyle = { ...paddingLeft,
    ...paddingTop
  };
  useEffect(() => {
    renderRoutes(locale);
    const routeConfig = routeMap.current.get(pathname); // console.log('routeConfig');
    // console.log(routeConfig);

    if (routeConfig) {
      if (routeConfig.indexOf('multiplePlayer') == 0) {
        setNavigationHidden(true);
      } else {
        setNavigationHidden(false);
      }
    } // setBreadCrumb(routeConfig || []);

  }, [pathname]);

  function renderAll() {
    if (navigationHidden) {
      return /*#__PURE__*/React.createElement(_Layout, {
        className: styles['layout-content']
      }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Switch, null, flattenRoutes.map((route, index) => {
        return /*#__PURE__*/React.createElement(Route, {
          key: index,
          path: `/${route.key}`,
          component: route.component
        });
      }), /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/"
      }, /*#__PURE__*/React.createElement(Redirect, {
        to: `/${defaultRoute}`
      })), /*#__PURE__*/React.createElement(Route, {
        path: "*",
        component: lazyload(() => import('./pages/exception/403'))
      }))));
    } else {
      return /*#__PURE__*/React.createElement(_Layout, {
        className: styles.layout
      }, /*#__PURE__*/React.createElement("div", {
        className: cs(styles['layout-navbar'], {
          [styles['layout-navbar-hidden']]: !showNavbar
        })
      }, /*#__PURE__*/React.createElement(Navbar, {
        show: showNavbar
      })), /*#__PURE__*/React.createElement(_Layout, null, showMenu && /*#__PURE__*/React.createElement(Sider, {
        className: styles['layout-sider'],
        width: menuWidth,
        collapsed: collapsed,
        onCollapse: setCollapsed,
        trigger: null,
        collapsible: true,
        breakpoint: "xl",
        style: paddingTop
      }, /*#__PURE__*/React.createElement("div", {
        className: styles['menu-wrapper']
      }, /*#__PURE__*/React.createElement(_Menu, {
        collapse: collapsed,
        onClickMenuItem: onClickMenuItem,
        selectedKeys: selectedKeys,
        openKeys: openKeys,
        onClickSubMenu: (_, openKeys) => setOpenKeys(openKeys)
      }, renderRoutes(locale))), /*#__PURE__*/React.createElement("div", {
        className: styles['collapse-btn'],
        onClick: toggleCollapse
      }, collapsed ? /*#__PURE__*/React.createElement(_IconMenuUnfold, null) : /*#__PURE__*/React.createElement(_IconMenuFold, null))), /*#__PURE__*/React.createElement(_Layout, {
        className: styles['layout-content'],
        style: paddingStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: styles['layout-content-wrapper']
      }, !!breadcrumb.length && /*#__PURE__*/React.createElement("div", {
        className: styles['layout-breadcrumb']
      }, /*#__PURE__*/React.createElement(_Breadcrumb, null, breadcrumb.map((node, index) => index == 0 ? /*#__PURE__*/React.createElement(_IconHome, {
        key: index
      }) : /*#__PURE__*/React.createElement(_Breadcrumb.Item, {
        key: index
      }, typeof node === 'string' ? locale[node] || node : node)))), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Switch, null, flattenRoutes.map((route, index) => {
        return /*#__PURE__*/React.createElement(Route, {
          key: index,
          path: `/${route.key}`,
          component: route.component
        });
      }), /*#__PURE__*/React.createElement(Route, {
        exact: true,
        path: "/"
      }, /*#__PURE__*/React.createElement(Redirect, {
        to: `/${defaultRoute}`
      })), /*#__PURE__*/React.createElement(Route, {
        path: "*",
        component: lazyload(() => import('./pages/exception/403'))
      })))), showFooter && /*#__PURE__*/React.createElement(Footer, null))));
    }
  }

  return /*#__PURE__*/React.createElement("div", null, renderAll());
}

export default PageLayout;